import React from 'react'
import PropTypes from 'prop-types'
import connector from './connector'
import { inputState as inputDefaultState } from './reducer'
import { TEXT } from './constants'

/* eslint-disable react/sort-comp, no-unused-vars */
export default ({ name }) => Component => {
  class ShowHidePassword extends React.Component {
    componentDidMount() {
      this.props.register({ name })
    }

    componentWillUnmount() {
      this.props.unregister({ name })
    }

    handleChangeType = () => {
      this.props.changeType({ name })
    }

    handleBlur = () => {
      const { type } = this.props.inputState[name] || inputDefaultState
      if (type === TEXT) {
        this.props.changeType({ name })
      }
    }

    render() {
      const {
        register, unregister, changeType, // unnecessary props
        inputState,
        ...props
      } = this.props

      const { type } = inputState[name] || inputDefaultState

      return <Component { ...props } type={ type } changeType={ this.handleChangeType } blurType={ this.handleBlur } />
    }
  }

  ShowHidePassword.propTypes = {
    changeType: PropTypes.func,
    inputState: PropTypes.shape(),
    register: PropTypes.func,
    unregister: PropTypes.func
  }

  ShowHidePassword.displayName = `withShowHidePassword(${Component.displayName || Component.name})`

  return connector(ShowHidePassword)
}

